import $ from 'jquery'


/*
jQuery iife to filter out all links that targets a gallery and trigger the gallery to be displayed
 */
$((): void => {
	const triggers = $('a[href^="#"].link-more')

	if (!triggers.length) {
		return
	}

	triggers.on('click', (e): void => {
		const anchor = $(e.target).first().attr('href')
		if (!anchor || !anchor.length) {
			return
		}

		const gallery = $(anchor)
		if (!gallery || !gallery.length) {
			return
		}

		const galleryLink = gallery.find('.gallery-link').first()
		if (!galleryLink || !galleryLink.length) {
			return
		}

		e.preventDefault()
		galleryLink.trigger('click')
	})
});
